export interface CaseScope {
  id: string
  caseId: string
  content: string
  contentFormat: string
  currentVersion: number
  createdAt: string
  createdBy: string
  updatedAt: string
  updatedBy: string
}

export interface CaseScopeVersion {
  id: string
  version: number
  content: string
  contentFormat: string
  changeSummary: string | null
  createdAt: string
  createdBy: string
}

export interface CaseScopeVersionList {
  versions: CaseScopeVersion[]
  total: number
}

export interface CaseScopeNote {
  id: string
  caseId: string
  content: string
  tags: string[]
  createdAt: string
  createdBy: string
  updatedAt: string | null
  updatedBy: string | null
}

export interface CaseScopeNoteList {
  notes: CaseScopeNote[]
  total: number
}

export interface UpdateScopeRequest {
  content: string
  contentFormat?: string
  changeSummary?: string
}

export interface CreateScopeNoteRequest {
  content: string
  tags?: string[]
}

export interface UpdateScopeNoteRequest {
  content: string
  tags?: string[]
}

export interface ListVersionsQuery {
  limit?: number
  offset?: number
}

export interface ListNotesQuery {
  tag?: string
  limit?: number
  offset?: number
}

export type ScopeNoteTag = 'hypothesis' | 'question' | 'finding' | 'action' | 'important'

export const VALID_SCOPE_NOTE_TAGS: ScopeNoteTag[] = [
  'hypothesis',
  'question',
  'finding',
  'action',
  'important',
]
